import ButtonLink from '../ButtonLink';
import CardTourismPoints from '../CardTourismPoints';
import styles from './TourismPoints.module.css';
import { tourismData } from '../../database/tourismData';
import FadeInSection from '../FadeInSection';

export default function TourismPoints() {
  return (
    <section className={styles.tourismPoints}>
      <FadeInSection>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.titleWrapper}>
              <div className={styles.badge}>
                <div className={styles.line}></div>
                <span>Nossas Raízes</span>
                <div className={styles.line}></div>
              </div>
              <h2>Pontos Turísticos</h2>
            </div>
            <ButtonLink path='/pontos-turisticos'>Ver mais</ButtonLink>
          </div>
          <div className={styles.cards}>
            {tourismData.slice(0, 3).map(({ id, nome, descricao, url, imagem }) => (
              <CardTourismPoints
                key={id.toString()}
                id={id}
                nome={nome}
                descricao={descricao}
                url={url}
                imagem={imagem}
              />
            ))}
          </div>
          <div className={styles.mapAction}>
            <ButtonLink path="/mapa">Explorar mapa</ButtonLink>
          </div>
        </div>
      </FadeInSection>
    </section>
  );
}
